module.exports = __webpack_public_path__ + "img/shop9de.43ded284.png";